import { defineMessages } from 'react-intl';

export const connectEosBannerMessages: ReturnType<typeof defineMessages> = defineMessages({
	adminMessageWithAppName: {
		id: 'connect-module-core.eos.adminMessageWithAppName',
		defaultMessage:
			"The {appName} app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps.",
		description:
			'Warning message shown to site admins when a Connect app with a known app name uses a platform that will be unsupported after December 2026.',
	},
	adminMessageWithoutAppName: {
		id: 'connect-module-core.eos.adminMessageWithoutAppName',
		defaultMessage:
			"This app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps.",
		description:
			'Warning message shown to site admins when a Connect app without a known app name uses a platform that will be unsupported after December 2026.',
	},
	nonAdminMessageWithAppName: {
		id: 'connect-module-core.eos.nonAdminMessageWithAppName',
		defaultMessage:
			"The {appName} app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin.",
		description:
			'Warning message shown to users who are not site admins when a Connect app with a known app name uses a platform that will be unsupported after December 2026.',
	},
	nonAdminMessageWithoutAppName: {
		id: 'connect-module-core.eos.nonAdminMessageWithoutAppName',
		defaultMessage:
			"This app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin.",
		description:
			'Warning message shown to users who are not site admins when a Connect app without a known app name uses a platform that will be unsupported after December 2026.',
	},
	devCanaryMessage: {
		id: 'connect-module-core.eos.devCanaryMessage',
		defaultMessage:
			"You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>.",
		description:
			'Additional warning message shown in the Connect app platform warning banner when the tenant is enrolled in the Developer Canary Program. The Developer Canary Program and Forge changelog text are links to documentation where users can learn why the warning appears and watch release updates.',
	},
	dismiss: {
		id: 'connect-module-core.eos.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Action text for dismissing the Connect app platform warning message.',
	},
	inlineSecondaryText: {
		id: 'connect-module-core.eos.inlineSecondaryText',
		defaultMessage: 'This app might stop working soon',
		description: 'Short warning summary shown in the inline Connect app platform warning message.',
	},
});
